import React from "react";
import { Card, Row, Col, Image } from "react-bootstrap";

const OverviewDataCards = ({ overviewDetails }) => {
    return (
        <Row className="all-cards">
            {overviewDetails.map((item, index) => (
                <Col lg={3} md={6} key={index} className="mb-3 mb-lg-0">
                    <Card className="p-3 h-100" style={{ border: '2px solid #ECEEF5' }}>
                        <div className="d-flex content ">
                            <figure className="mb-1 me-2">
                                <Image src={item.icon} width={50} alt="icon" />
                            </figure>
                            <h5 className="fw-bold text-dark my-auto" style={{ fontSize: '40px' }}>

                                {item.value}
                            </h5>
                        </div>

                        <p className="mb-0" style={{ fontSize: '18px' }}>{item.label}</p>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default OverviewDataCards;
